var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.30036",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "codemirror-dlb": "static-1.51364",
      "collaboration-sidebar": "static-1.50416",
      "ContentComponents": "static-2.64530",
      "ContentData": "static-1.61649",
      "ContentEditorUI": "static-2.69812",
      "ContentUtils": "static-1.61572",
      "data-fetching-client": "static-1.7860",
      "editor-components": "static-1.11294",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.32353",
      "foundations-assets": "static-1.3218",
      "foundations-components": "static-1.5440",
      "head-dlb": "static-1.3234",
      "hs-test-utils": "static-1.6310",
      "hub-http": "static-1.4514",
      "hub-http-shared-msw-handlers": "static-1.6509",
      "hubspot-dlb": "static-2.1067",
      "HubStyleTokens": "static-2.9834",
      "I18n": "static-7.1347",
      "InpageEditorUI": "static-1.78255",
      "jasmine-immutable": "static-1.1326",
      "jasmine-runner": "static-1.4719",
      "layout-dnd-utils": "static-1.9187",
      "marketing-discovery-utils": "static-1.2291",
      "quartz": "static-1.5074",
      "react-dlb": "static-1.47",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.3944",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.10875",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4360",
      "ui-components-test-utils": "static-1.3974",
      "ui-images": "static-2.790",
      "ui-memberships-settings-lib": "static-1.26377",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.4604",
      "apollo-stack-hubspot": "static-3.43",
      "atom": "static-1.3639",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.20448",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.5741",
      "content-management-data-lib": "static-1.3401",
      "copilot-plugins": "static-1.4515",
      "copilot-toolkit": "static-1.4541",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.387",
      "cta-picker": "static-1.29523",
      "customer-data-objects": "static-1.5927",
      "customer-data-objects-ui-components": "static-1.11209",
      "customer-data-properties": "static-1.43852",
      "customer-data-property-utils": "static-1.6242",
      "customer-data-reference-ui-components": "static-1.11256",
      "customer-data-ui-utilities": "static-1.8061",
      "data-token-picker": "static-1.13274",
      "data-token-views": "static-1.13258",
      "error-messaging-js": "static-1.3626",
      "feedback-loader": "static-1.25719",
      "file-manager-components": "static-1.16712",
      "FileManagerCore": "static-1.32212",
      "FormsCommonComponents": "static-1.79328",
      "foundations-theming": "static-1.2601",
      "fuzzy": "static-1.8",
      "growth-onboarding-confetti": "static-1.1445",
      "growth-payments-core": "static-1.19734",
      "history": "static-4.47",
      "hs-lodash": "static-4.40",
      "hs-promise-utils": "static-1.3809",
      "hub-http-contrib": "static-1.1519",
      "hubspot-url-utils": "static-1.2717",
      "HubStyle": "static-2.10143",
      "icons": "static-2.589",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.8988",
      "integrations-lib": "static-1.9229",
      "interframe": "static-3.3119",
      "laboratory-lib": "static-3.5595",
      "layout-data-lib": "static-1.7512",
      "media-bridge-lib": "static-1.15918",
      "nav-meta": "static-1.24707",
      "object-builder-ui-client": "static-1.39760",
      "onboarding-scopes": "static-1.4890",
      "onboarding-tours": "static-1.13520",
      "onboarding-tours-client": "static-1.2856",
      "outpost": "static-1.2583",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.16747",
      "payments-post-enroll-local-storage-lib": "static-1.3411",
      "pictos": "static-7.157",
      "PortalIdParser": "static-2.263",
      "products-ui-components": "static-1.33935",
      "property-translator": "static-1.3729",
      "quick-fetch": "static-1.2224",
      "raven": "static-3.3936",
      "react": "static-7.147",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.8560",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.44",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.14940",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.49022",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.71",
      "redux": "static-4.16",
      "redux-request-state": "static-1.8915",
      "reference-resolvers": "static-1.6465",
      "reference-resolvers-lite": "static-1.6268",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.16680",
      "sanitize": "static-1.2696",
      "sanitize-text": "static-1.6524",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.8464",
      "SharedI18nStrings": "static-1.160",
      "SharedLegalStrings": "static-1.1270",
      "simple-menus-core": "static-1.12979",
      "simple-menus-lib": "static-1.14497",
      "smart-content-lib": "static-1.36207",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.446",
      "superstore": "static-1.3105",
      "theme-previewer-lib": "static-1.45937",
      "tinymce-config": "static-2.48148",
      "tinymce-copilot": "static-1.10216",
      "tinymce-data": "static-1.34231",
      "tinymce-plugins": "static-1.51262",
      "tinymce-themes": "static-1.50116",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.7763",
      "ui-addon-emoji-picker": "static-1.8248",
      "ui-addon-form-validation": "static-1.9361",
      "ui-addon-i18n": "static-1.9238",
      "ui-addon-iframeable": "static-1.7233",
      "ui-addon-opt": "static-4.7037",
      "ui-addon-sales-email": "static-1.3546",
      "ui-addon-upgrades": "static-9.15317",
      "ui-business-units-lib": "static-1.7183",
      "ui-gdpr-components": "static-1.8584",
      "ui-product-approvals": "static-1.22778",
      "ui-shepherd-react": "static-3.8323",
      "ui-suspension-banners-lib": "static-1.4745",
      "UIComponents": "static-3.6783",
      "underscore": "static-1.8",
      "urlinator": "static-1.2897",
      "usage-tracker": "static-1.5807",
      "usage-tracker-core": "static-1.5657",
      "user-context": "static-1.3481",
      "video-embed": "static-1.28603",
      "web-interactives-components": "static-1.10733",
      "web-interactives-data": "static-1.10734",
      "wootric-nps": "static-1.5327",
      "xray-recommendation-lib": "static-1.5205",
      "codemirror": "static-5.67",
      "react-codemirror": "static-1.8921",
      "enviro": "static-4.284",
      "hs-promise-rejection-tracking": "static-1.3563",
      "raven-hubspot": "static-1.4243",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.8026",
      "bend-plugin-trellis-migration": "static-1.2054",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.7879",
      "chatspot-core": "static-1.13774",
      "chatspot-widget-iframe": "static-1.13770",
      "framework-data-schema-resolvers": "static-1.5126",
      "frontend-preferences-client": "static-1.6217",
      "graphql": "static-1.56",
      "quartz-core": "static-1.4293",
      "cms-field-types": "static-1.3125",
      "content-embed-lib": "static-1.5540",
      "ExportDialog": "static-6.8713",
      "forms-utils-lib": "static-1.9372",
      "integrations-error-boundary-lib": "static-1.6643",
      "payments-embed-points-lib": "static-1.8260",
      "react-dnd-compat": "static-1.2937",
      "usage-tracker-container": "static-1.5797",
      "video-data-lib": "static-1.27760",
      "videoconference-integration-components": "static-1.4350",
      "editor-iframe-lib": "static-1.6607",
      "FireAlarmUi": "static-1.3267",
      "hubspot-apollo-client": "static-1.3158",
      "layout-dnd-components": "static-1.10212",
      "marketing-email-service-types": "static-1.1235",
      "rpc-client-utils": "static-1.3070",
      "smart-content-core": "static-1.35552",
      "social-composer-lib": "static-1.51929",
      "structured-content-lib": "static-1.18520",
      "timezone-utils": "static-2.3610",
      "ui-active-theme-content-creator-lib": "static-1.29716",
      "ui-addon-video-player": "static-1.7110",
      "ui-asset-management-lib": "static-1.8385",
      "ui-tool-access": "static-1.8360",
      "content-icons-ui": "static-1.1847",
      "react-aria": "static-1.36",
      "FileManagerImages": "static-1.29863",
      "hs-story-utils": "static-1.7675",
      "bend-plugin-foundations-components": "static-1.1708",
      "floating-ui": "static-1.26",
      "foundations-theming-specialty": "static-1.318",
      "framer-motion": "static-1.38",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.329",
      "HeadJS": "static-2.547",
      "hs-test-utils-bend-plugin": "static-1.1421",
      "msw": "static-1.39",
      "testing-library": "static-1.118",
      "ts-schema": "static-1.2764",
      "i18n-data": "static-1.194",
      "moment-timezone": "static-5.51",
      "NamespacedHubStyle": "static-2.7849",
      "react-dnd-ipeui-backend": "static-1.488",
      "ui-coaching-tips": "static-1.20552",
      "jasmine": "static-4.2690",
      "quartz-core-utils": "static-1.1941",
      "flux-actions": "static-1.262",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.8794",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.2926",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.1586",
      "sassPrefix": "static-1.128",
      "attribution-lib": "static-1.36058",
      "campaigns-build-lib": "static-1.5522",
      "crm-pipelines-api-client-types": "static-1.2723",
      "marketing-platform-lib": "static-1.4985",
      "ai-rendering-library": "static-1.3536",
      "ui-brand-identity-lib": "static-1.6479",
      "avatar-components": "static-1.736",
      "commerce-products-lib": "static-1.3412",
      "conditional-properties-service-client": "static-1.2570",
      "crm-links": "static-1.4417",
      "crm-message-bus": "static-1.34586",
      "enrichment-properties-lib": "static-1.8058",
      "external-options-client-types": "static-1.2717",
      "google-libphonenumber": "static-1.9",
      "inbound-db-properties-service-client": "static-1.2571",
      "inbounddb-objects-service-types": "static-1.2751",
      "pipeline-validation-client-types": "static-1.2511",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.496",
      "forms-ai-lib": "static-1.1665",
      "bend-plugin-foundations-theming": "static-1.1084",
      "commerce-analytics-service-client": "static-1.2125",
      "integrations-tracking-lib": "static-1.3735",
      "native-integrations-shared-strings": "static-1.6130",
      "getting-started-shared-tasks": "static-1.10119",
      "growth-data-modal": "static-1.3498",
      "navigation-components": "static-1.13070",
      "ui-shepherd-tracker": "static-1.5704",
      "ui-universal-auth": "static-1.7070",
      "commerce-tours-lib": "static-1.2742",
      "growth-onboarding-reliability": "static-1.3482",
      "sales-checkout-service-client": "static-1.2137",
      "commerce-shared-components-lib": "static-1.13487",
      "commerce-subscription-lib": "static-1.29542",
      "crm_components": "static-3.85185",
      "crm_data": "static-4.85185",
      "customer-data-filters-ui": "static-1.32117",
      "customer-data-tracking": "static-1.5153",
      "dispatcher": "static-1.109",
      "framework-data-table": "static-2.7440",
      "property-description-translator": "static-1.2191",
      "csstype": "static-1.38",
      "fast-json-stable-stringify": "static-1.4",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3151",
      "feature-store-service-types": "static-1.3015",
      "growth-monetization-service-types": "static-1.3022",
      "upgrade-management-service-types": "static-1.3006",
      "permission-components": "static-1.3695",
      "getting-started-shared-tasks-store": "static-1.9237",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "framework-builder-read-service-client": "static-1.2689",
      "framework-data-schema-quick-fetch": "static-1.5031",
      "inbound-db-meta-service-client": "static-1.2375",
      "persist-promise": "static-1.2081",
      "hub-http-janus": "static-1.617",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.6507",
      "mobile-manifest-mixins": "static-1.318",
      "platform-navigation-bootstrap": "static-1.10578",
      "payments-enrollment-embed-lib": "static-1.16169",
      "apollo-link-hub-http": "static-2.3134",
      "growth-onboarding-feedback-components": "static-1.4789",
      "FormUrlGenerator": "static-2.3060",
      "highcharts": "static-8.77",
      "report-customization-components": "static-1.7294",
      "reporting-action-components": "static-1.34427",
      "reporting-data": "static-1.59916",
      "reporting-enablement": "static-1.15221",
      "reporting-snowflake": "static-1.48542",
      "reporting-ui-components": "static-2.57199",
      "reporting-visualizations": "static-1.51996",
      "customer-data-filters": "static-1.45931",
      "highlight.js": "static-1.45",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "ui-addon-teams": "static-1.19035",
      "products-ui-components-shared-msw-handlers": "static-1.6894",
      "location-customization-utils-lib": "static-1.2548",
      "breeze-intelligence-kit": "static-1.3496",
      "crm-source-interpretation-lib": "static-1.3597",
      "fsm": "static-1.2041",
      "policy-lib": "static-1.5134",
      "final-form": "static-1.37",
      "redux-toolkit": "static-1.7",
      "universal-page-editor-lib": "static-1.1287",
      "idb-keyval": "static-1.18",
      "magpie-lib": "static-1.3980",
      "magpie-types": "static-1.3440",
      "simple-logging-lib": "static-1.1391",
      "commerce-billing-lib": "static-1.13252",
      "commerce-contract-lib": "static-1.4088",
      "commerce-tools-ui-lib": "static-1.5099",
      "conversations-skeleton-state": "static-1.5733",
      "crm_universal": "static-1.20041",
      "customer-data-content": "static-1.23536",
      "crm_schema": "static-3.85220",
      "customer-data-email": "static-1.15034",
      "customer-data-filters-ui-msw-helpers": "static-1.14549",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.5523",
      "platform-infra-nav-components": "static-1.6278",
      "marketplace-ui-apps-core": "static-1.11068",
      "stripe-embedded-components": "static-1.4446",
      "dashboard-lib": "static-1.73894",
      "share-with-third-party-component-lib": "static-1.6960",
      "reporting-client-types": "static-1.1609",
      "data-quality-ui-library": "static-1.6220",
      "html-to-image": "static-1.27",
      "reporting-plugins": "static-1.5588",
      "reporting-reports": "static-1.59605",
      "reporting-datasets-permissions-lib": "static-1.5426",
      "deep-diff": "static-1.5",
      "multi-currency-client-types": "static-1.2487",
      "sales-views-client-types": "static-1.2734",
      "crm-record-cards-service-types": "static-1.2412",
      "trellis-story-utils": "static-1.2878",
      "usage-tracker-session-replay": "static-1.2954",
      "utility-belt": "static-1.915",
      "crm-cards-sdk": "static-1.36414",
      "customer-data-rte": "static-1.27618",
      "cv-backend-services": "static-1.1007",
      "growth-onboarding-empty-states": "static-1.3414",
      "hubspot-prosemirror": "static-1.12257",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.41",
      "SalesContentIndexUI": "static-3.6267",
      "sequences-lib": "static-1.5140",
      "developer-experience-shared-components": "static-1.8339",
      "immutable-less": "static-1.2906",
      "marketplace-ui-client-types": "static-1.9936",
      "marketplace-ui-common": "static-1.12532",
      "ui-addon-integrations-directory-panel": "static-2.6297",
      "ui-extensibility-client-types": "static-1.2608",
      "stripe-connect-js": "static-1.35",
      "redux-actions": "static-3.7",
      "ui-addon-react-router-dom": "static-1.7934",
      "campaign-roi-lib": "static-1.962",
      "amplitude-session-replay-browser": "static-1.6",
      "crm-actions": "static-1.4328",
      "crm-fe-perf": "static-1.21316",
      "draft-content-plugins": "static-1.22937",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.18497",
      "knowledge-content-types": "static-1.7406",
      "sequences-client-types-lib": "static-1.4996",
      "apps-service-types": "static-1.2639",
      "oauth-service-types": "static-1.2570",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.30036",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "codemirror-dlb": "/codemirror-dlb/static-1.51364",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.50416",
      "ContentComponents": "/ContentComponents/static-2.64530",
      "ContentData": "/ContentData/static-1.61649",
      "ContentEditorUI": "/ContentEditorUI/static-2.69812",
      "ContentUtils": "/ContentUtils/static-1.61572",
      "data-fetching-client": "/data-fetching-client/static-1.7860",
      "editor-components": "/editor-components/static-1.11294",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.32353",
      "foundations-assets": "/foundations-assets/static-1.3218",
      "foundations-components": "/foundations-components/static-1.5440",
      "head-dlb": "/head-dlb/static-1.3234",
      "hs-test-utils": "/hs-test-utils/static-1.6310",
      "hub-http": "/hub-http/static-1.4514",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6509",
      "hubspot-dlb": "/hubspot-dlb/static-2.1067",
      "HubStyleTokens": "/HubStyleTokens/static-2.9834",
      "I18n": "/I18n/static-7.1347",
      "InpageEditorUI": "/InpageEditorUI/static-1.78255",
      "jasmine-immutable": "/jasmine-immutable/static-1.1326",
      "jasmine-runner": "/jasmine-runner/static-1.4719",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.9187",
      "marketing-discovery-utils": "/marketing-discovery-utils/static-1.2291",
      "quartz": "/quartz/static-1.5074",
      "react-dlb": "/react-dlb/static-1.47",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.3944",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.10875",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4360",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.3974",
      "ui-images": "/ui-images/static-2.790",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.26377",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4604",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "atom": "/atom/static-1.3639",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.20448",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.5741",
      "content-management-data-lib": "/content-management-data-lib/static-1.3401",
      "copilot-plugins": "/copilot-plugins/static-1.4515",
      "copilot-toolkit": "/copilot-toolkit/static-1.4541",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.387",
      "cta-picker": "/cta-picker/static-1.29523",
      "customer-data-objects": "/customer-data-objects/static-1.5927",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11209",
      "customer-data-properties": "/customer-data-properties/static-1.43852",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.6242",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11256",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8061",
      "data-token-picker": "/data-token-picker/static-1.13274",
      "data-token-views": "/data-token-views/static-1.13258",
      "error-messaging-js": "/error-messaging-js/static-1.3626",
      "feedback-loader": "/feedback-loader/static-1.25719",
      "file-manager-components": "/file-manager-components/static-1.16712",
      "FileManagerCore": "/FileManagerCore/static-1.32212",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.79328",
      "foundations-theming": "/foundations-theming/static-1.2601",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1445",
      "growth-payments-core": "/growth-payments-core/static-1.19734",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.40",
      "hs-promise-utils": "/hs-promise-utils/static-1.3809",
      "hub-http-contrib": "/hub-http-contrib/static-1.1519",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2717",
      "HubStyle": "/HubStyle/static-2.10143",
      "icons": "/icons/static-2.589",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.8988",
      "integrations-lib": "/integrations-lib/static-1.9229",
      "interframe": "/interframe/static-3.3119",
      "laboratory-lib": "/laboratory-lib/static-3.5595",
      "layout-data-lib": "/layout-data-lib/static-1.7512",
      "media-bridge-lib": "/media-bridge-lib/static-1.15918",
      "nav-meta": "/nav-meta/static-1.24707",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.39760",
      "onboarding-scopes": "/onboarding-scopes/static-1.4890",
      "onboarding-tours": "/onboarding-tours/static-1.13520",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.2856",
      "outpost": "/outpost/static-1.2583",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.16747",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3411",
      "pictos": "/pictos/static-7.157",
      "PortalIdParser": "/PortalIdParser/static-2.263",
      "products-ui-components": "/products-ui-components/static-1.33935",
      "property-translator": "/property-translator/static-1.3729",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "raven": "/raven/static-3.3936",
      "react": "/react/static-7.147",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.8560",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.44",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.14940",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.49022",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.71",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.8915",
      "reference-resolvers": "/reference-resolvers/static-1.6465",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6268",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.16680",
      "sanitize": "/sanitize/static-1.2696",
      "sanitize-text": "/sanitize-text/static-1.6524",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.8464",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1270",
      "simple-menus-core": "/simple-menus-core/static-1.12979",
      "simple-menus-lib": "/simple-menus-lib/static-1.14497",
      "smart-content-lib": "/smart-content-lib/static-1.36207",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.446",
      "superstore": "/superstore/static-1.3105",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.45937",
      "tinymce-config": "/tinymce-config/static-2.48148",
      "tinymce-copilot": "/tinymce-copilot/static-1.10216",
      "tinymce-data": "/tinymce-data/static-1.34231",
      "tinymce-plugins": "/tinymce-plugins/static-1.51262",
      "tinymce-themes": "/tinymce-themes/static-1.50116",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7763",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8248",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9361",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9238",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7233",
      "ui-addon-opt": "/ui-addon-opt/static-4.7037",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3546",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15317",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.7183",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.8584",
      "ui-product-approvals": "/ui-product-approvals/static-1.22778",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.8323",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.4745",
      "UIComponents": "/UIComponents/static-3.6783",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.2897",
      "usage-tracker": "/usage-tracker/static-1.5807",
      "usage-tracker-core": "/usage-tracker-core/static-1.5657",
      "user-context": "/user-context/static-1.3481",
      "video-embed": "/video-embed/static-1.28603",
      "web-interactives-components": "/web-interactives-components/static-1.10733",
      "web-interactives-data": "/web-interactives-data/static-1.10734",
      "wootric-nps": "/wootric-nps/static-1.5327",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5205",
      "codemirror": "/codemirror/static-5.67",
      "react-codemirror": "/react-codemirror/static-1.8921",
      "enviro": "/enviro/static-4.284",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3563",
      "raven-hubspot": "/raven-hubspot/static-1.4243",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.8026",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2054",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.7879",
      "chatspot-core": "/chatspot-core/static-1.13774",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.13770",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5126",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6217",
      "graphql": "/graphql/static-1.56",
      "quartz-core": "/quartz-core/static-1.4293",
      "cms-field-types": "/cms-field-types/static-1.3125",
      "content-embed-lib": "/content-embed-lib/static-1.5540",
      "ExportDialog": "/ExportDialog/static-6.8713",
      "forms-utils-lib": "/forms-utils-lib/static-1.9372",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.6643",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8260",
      "react-dnd-compat": "/react-dnd-compat/static-1.2937",
      "usage-tracker-container": "/usage-tracker-container/static-1.5797",
      "video-data-lib": "/video-data-lib/static-1.27760",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.4350",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.6607",
      "FireAlarmUi": "/FireAlarmUi/static-1.3267",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3158",
      "layout-dnd-components": "/layout-dnd-components/static-1.10212",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1235",
      "rpc-client-utils": "/rpc-client-utils/static-1.3070",
      "smart-content-core": "/smart-content-core/static-1.35552",
      "social-composer-lib": "/social-composer-lib/static-1.51929",
      "structured-content-lib": "/structured-content-lib/static-1.18520",
      "timezone-utils": "/timezone-utils/static-2.3610",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.29716",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.7110",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8385",
      "ui-tool-access": "/ui-tool-access/static-1.8360",
      "content-icons-ui": "/content-icons-ui/static-1.1847",
      "react-aria": "/react-aria/static-1.36",
      "FileManagerImages": "/FileManagerImages/static-1.29863",
      "hs-story-utils": "/hs-story-utils/static-1.7675",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1708",
      "floating-ui": "/floating-ui/static-1.26",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.318",
      "framer-motion": "/framer-motion/static-1.38",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.329",
      "HeadJS": "/HeadJS/static-2.547",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1421",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.118",
      "ts-schema": "/ts-schema/static-1.2764",
      "i18n-data": "/i18n-data/static-1.194",
      "moment-timezone": "/moment-timezone/static-5.51",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.7849",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.488",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.20552",
      "jasmine": "/jasmine/static-4.2690",
      "quartz-core-utils": "/quartz-core-utils/static-1.1941",
      "flux-actions": "/flux-actions/static-1.262",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.8794",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.2926",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.1586",
      "sassPrefix": "/sassPrefix/static-1.128",
      "attribution-lib": "/attribution-lib/static-1.36058",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.5522",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2723",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.4985",
      "ai-rendering-library": "/ai-rendering-library/static-1.3536",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.6479",
      "avatar-components": "/avatar-components/static-1.736",
      "commerce-products-lib": "/commerce-products-lib/static-1.3412",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2570",
      "crm-links": "/crm-links/static-1.4417",
      "crm-message-bus": "/crm-message-bus/static-1.34586",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.8058",
      "external-options-client-types": "/external-options-client-types/static-1.2717",
      "google-libphonenumber": "/google-libphonenumber/static-1.9",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2571",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.2751",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2511",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.496",
      "forms-ai-lib": "/forms-ai-lib/static-1.1665",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1084",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2125",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.3735",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6130",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.10119",
      "growth-data-modal": "/growth-data-modal/static-1.3498",
      "navigation-components": "/navigation-components/static-1.13070",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.5704",
      "ui-universal-auth": "/ui-universal-auth/static-1.7070",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.2742",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3482",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2137",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.13487",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.29542",
      "crm_components": "/crm_components/static-3.85185",
      "crm_data": "/crm_data/static-4.85185",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.32117",
      "customer-data-tracking": "/customer-data-tracking/static-1.5153",
      "dispatcher": "/dispatcher/static-1.109",
      "framework-data-table": "/framework-data-table/static-2.7440",
      "property-description-translator": "/property-description-translator/static-1.2191",
      "csstype": "/csstype/static-1.38",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3151",
      "feature-store-service-types": "/feature-store-service-types/static-1.3015",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3022",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3006",
      "permission-components": "/permission-components/static-1.3695",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.9237",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2689",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5031",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2375",
      "persist-promise": "/persist-promise/static-1.2081",
      "hub-http-janus": "/hub-http-janus/static-1.617",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6507",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.318",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10578",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.16169",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3134",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.4789",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.3060",
      "highcharts": "/highcharts/static-8.77",
      "report-customization-components": "/report-customization-components/static-1.7294",
      "reporting-action-components": "/reporting-action-components/static-1.34427",
      "reporting-data": "/reporting-data/static-1.59916",
      "reporting-enablement": "/reporting-enablement/static-1.15221",
      "reporting-snowflake": "/reporting-snowflake/static-1.48542",
      "reporting-ui-components": "/reporting-ui-components/static-2.57199",
      "reporting-visualizations": "/reporting-visualizations/static-1.51996",
      "customer-data-filters": "/customer-data-filters/static-1.45931",
      "highlight.js": "/highlight.js/static-1.45",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "ui-addon-teams": "/ui-addon-teams/static-1.19035",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.6894",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.2548",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3496",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3597",
      "fsm": "/fsm/static-1.2041",
      "policy-lib": "/policy-lib/static-1.5134",
      "final-form": "/final-form/static-1.37",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1287",
      "idb-keyval": "/idb-keyval/static-1.18",
      "magpie-lib": "/magpie-lib/static-1.3980",
      "magpie-types": "/magpie-types/static-1.3440",
      "simple-logging-lib": "/simple-logging-lib/static-1.1391",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.13252",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.4088",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5099",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5733",
      "crm_universal": "/crm_universal/static-1.20041",
      "customer-data-content": "/customer-data-content/static-1.23536",
      "crm_schema": "/crm_schema/static-3.85220",
      "customer-data-email": "/customer-data-email/static-1.15034",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.14549",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.5523",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6278",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.11068",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.4446",
      "dashboard-lib": "/dashboard-lib/static-1.73894",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.6960",
      "reporting-client-types": "/reporting-client-types/static-1.1609",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.6220",
      "html-to-image": "/html-to-image/static-1.27",
      "reporting-plugins": "/reporting-plugins/static-1.5588",
      "reporting-reports": "/reporting-reports/static-1.59605",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.5426",
      "deep-diff": "/deep-diff/static-1.5",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.2487",
      "sales-views-client-types": "/sales-views-client-types/static-1.2734",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2412",
      "trellis-story-utils": "/trellis-story-utils/static-1.2878",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
      "utility-belt": "/utility-belt/static-1.915",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.36414",
      "customer-data-rte": "/customer-data-rte/static-1.27618",
      "cv-backend-services": "/cv-backend-services/static-1.1007",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3414",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.12257",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.41",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6267",
      "sequences-lib": "/sequences-lib/static-1.5140",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8339",
      "immutable-less": "/immutable-less/static-1.2906",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.9936",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.12532",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6297",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2608",
      "stripe-connect-js": "/stripe-connect-js/static-1.35",
      "redux-actions": "/redux-actions/static-3.7",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7934",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.962",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
      "crm-actions": "/crm-actions/static-1.4328",
      "crm-fe-perf": "/crm-fe-perf/static-1.21316",
      "draft-content-plugins": "/draft-content-plugins/static-1.22937",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.18497",
      "knowledge-content-types": "/knowledge-content-types/static-1.7406",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.4996",
      "apps-service-types": "/apps-service-types/static-1.2639",
      "oauth-service-types": "/oauth-service-types/static-1.2570",
      "react-window": "/react-window/static-1.13"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};